import { IOutboundSms, OutboundEmailStatus } from "intake_shared/src/types";
import { v4 as uuidv4 } from "uuid";
import db from "../utils/firestore";
import { Collection } from "intake_shared/src/enum";

export async function queueSms(
    outbound_sms: IOutboundSms,
    status: OutboundEmailStatus = OutboundEmailStatus.UNSCHEDULED
) {
    const id = uuidv4();
    const todays_date = new Date();
    const updated_outbound_sms: IOutboundSms = {
        ...outbound_sms,
        id,
        created_at: todays_date,
        updated_at: todays_date,
        status,
        retries: 0,
        last_error: {},
    };

    await db
        .collection(Collection.OUTBOUND_SMS)
        .doc(id)
        .set({ ...updated_outbound_sms });
}

export async function fetchOutboundSms(client_phone = "") {
    let query = db
        .collection(Collection.OUTBOUND_SMS)
        .where("to", "==", client_phone);

    query = query.orderBy("created_at", "desc");
    const raw_data = await (await query.get()).docs;
    const outbound_sms: IOutboundSms[] = raw_data.map((r) => {
        return r.data() as IOutboundSms;
    });
    return outbound_sms;
}
